import { takeLatest, takeEvery, put, delay, fork, cancel, take, select } from 'redux-saga/effects';
import api, { S3Instance, api2, getToken } from '../../../../utils/apiConfig';
import * as Sentry from '@sentry/react';
import MarketPlaceActionTypes from './types';
import {
  fetchOperatorTripsSuccess,
  fetchTripExpenseSuccess,
  fetchPaymentHistorySuccess,
  fetchTripSummarySuccess,
  saveOpResponseSuccess,
  saveOpResponseRejected,
  fetchStatesSuccess,
  fetchLoadsSuccess,
  callPocSuccess,
  fetchLoadDetailsSuccess,
  postLoadQuoteSuccess,
  fetchLoadQuoteQualitySuccess,
  getSearchOptionsSuccess,
  podResourceKey,
  getUploadedImagesSuccess,
  fetchPodDetailsActionSuccess,
  PodPostUploadDocSubmitSuccess,
  postLoadQuoteFailure,
  getPlaceholderBannerDetailSuccess,
  unLoadingSearchResultsSuccess,
  vehicleAvailModalShowSuccess,
  surveyGetQuestionSuccess,
  podAwsImgUrl,
  initiateMembershipPaymentSuccess,
  initiateMembershipPaymentFailure,
  membershipPaymentProcessSuccess,
  membershipPaymentProcessFailure,
  fetchOperatorProfileDetailsFailure,
  otpSubmitActionFailure,
  fetchAppConfigSuccess,
  fetchAppConfigFailure,
  fetchOperatorProfileDetailsSuccess,
  fetchTripTrackingSuccess,
  mergeTripPodOtpWidgets,
  startTripPodOtpPoll,
  stopTripPodOtpPoll,
  uploadImgAwsSuccess,
  submitBulkUploadSuccess,
  submitBulkUploadFailure,
  imgUploadStatus,
  resetPODDto,
  sendResponseEventSuccess,
  sendResponseEventFailure,
  fetchLoadDetailsFailure,
  otpStageSubmitActionSuccess,
  tripDetailStateChangeConfirmWarningStop,
  tripDetailStateChangeValidationFailure,
  fetchOperatorDetailsSuccess,
  fetchOperatorDetailsFailure,
  initiateOperatorTdsDeclarationFailure,
  initiateOperatorTdsDeclarationSuccess,
  fetchTripTrackingFailure,
  getAppConfigV2Success,
  getAppConfigV2Failure,
  patchAppConfigV2Success,
  patchAppConfigV2Failure,
  fetchLoadsFailure,
  getTripRemarksSuccess,
  getTripRemarksFailure,
  getTripSlotsFailure,
  getTripSlotsSuccess,
  fetchOperatorTicketSuccess,
  fetchOperatorTicketFailure,
  fetchLoadDetailsStart,
  fetchLoadsStart,
  fetchOperatorPolicyStatusSuccess,
  fetchOperatorPolicyStatusFailure,
  fetchOperatorPolicyStatusReset,
  postOperatorPolicyAcceptFailure,
  fetchSubscriptionSuccess,
  fetchSubscriptionFailure,
  updateCancelReasonSuccess,
  updateCancelReasonFailure,
  fetchTripFiltersDataSuccess,
  fetchTripFiltersDataFailure,
  applyTripFilter,
  fetchOperatorTripsFailure,
  fetchSettingsSuccess,
  fetchSettingsFailure,
  saveSettingsSuccess,
  saveSettingsFailure,
  demandEditConfirmationsFailure,
  demandEditConfirmationSuccess,
  getRatingTrainingFailure,
  getRatingTrainingSuccess,
  getInvoiceSuccess,
  getInvoiceFailure,
  patchInvoiceSuccess,
  patchInvoiceFailure,
  uploadImageSuccess,
  uploadImageFailure,
  uploadImageAwsRequest,
  uploadImageAwsFailure,
  uploadImageAwsSuccess,
  fetchWeLangSuccess,
  fetchWeLangFailure,
  fetchTrainingContentSuccess,
  fetchTrainingContentFailure,
  fetchTrainingContentV2Success,
  fetchTrainingContentV2Failure,
  sessionUpdateSuccess,
  sessionUpdateFailure,
  submitTrainingCompletionSuccess,
  submitTrainingCompletionFailure,
  postAcknowledgementSuccess,
  postAcknowledgementFailure,
  fetchDetentionContentSuccess,
  fetchDetentionContentFailure,
  asyncFetchRateCardsSuccess,
  asyncFetchRateCardsFailure,
  asyncPostSubmitRateCardResponseSuccess,
  asyncPostSubmitRateCardResponseFailure,
  asyncGetRemarksListSuccess,
  asyncGetRemarksListFailure,
  updateDelayRemarksSuccess,
  updateDelayRemarksFailure,
  reasonSubmitSuccess,
  reasonSubmitFailure,
  fetchAdvanceStateViewSuccess,
  fetchAdvanceStateViewFailure,
  fetchAdvanceStateViewStart,
} from './actions';
import { showSnackBar } from '../../../../components/UI/HOC/SnackBar/store/actions';
import UrlConfig from './urls';
import { Filter } from '../../../../components/UI/templates/TripTempateV2/trips.spec';
import axios, { AxiosResponse } from 'axios';
import { showLoader } from '../../../../components/Loader/action';
import { RateCardsResponseDTO } from '../../../../components/UI/templates/TripDetailsTemplate/RateCardInputModal/contracts';

function* fetchOperatorTrips(action: any): any {
  const requestURL = UrlConfig.fetchOperatorTripsV2(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(fetchOperatorTripsSuccess(response.data));
  } catch (e) {
    yield put(fetchOperatorTripsFailure(e));
    console.log({ e });
  }
}

function* fetchStates() {
  const requestURL = UrlConfig.fetchStates();
  try {
    const response = yield api.get(requestURL);
    yield put(fetchStatesSuccess(response.data));
  } catch (e) {
    console.log({ e });
  }
}

function* fetchOperatorLoads(action: any) {
  const requestURL = UrlConfig.fetchOperatorLoads(action.payload);

  try {
    const response = yield api.get(requestURL);
    if (response) {
      yield put(fetchLoadsSuccess(response.data));
    }
  } catch (e) {
    yield put(fetchLoadsFailure());
    console.log({ e });
  }
}

function* saveOpResponse(action: any) {
  let formData = {
    loadConsent: action.payload.loadConsent === 'ACCEPTED' ? 'ACCEPTED' : 'REJECTED',
  };
  const requestURL = UrlConfig.setOpResponse(action.payload.demandId);
  try {
    const response = yield api.put(requestURL, formData);
    if (action.payload.loadConsent === 'ACCEPTED') {
      yield put(saveOpResponseSuccess(response.data.data));
    } else {
      yield put(saveOpResponseRejected(response.data.data));
      yield put(fetchLoadsStart(action.payload.demandId));
    }
  } catch (e) {
    console.log({ e });
  }
}

function* callPoc(action: any) {
  const requestURL = UrlConfig.callPoc(action.payload);
  try {
    const response = yield api.get(requestURL, action.payload);
    yield put(callPocSuccess(response.data));
  } catch (e) {
    console.log({ e });
  }
}

function* fetchTripExpenses(action: any) {
  const requestURL = UrlConfig.fetchTripExpense(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(fetchTripExpenseSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}
function* fetchTripExpensesV2(action: any) {
  const requestURL = UrlConfig.fetchTripExpenseV2(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(fetchTripExpenseSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* fetchTripTrackingDetails(action: any) {
  const requestURL = UrlConfig.fetchTripTracking(action.payload);
  try {
    const response = yield api.get(requestURL);
    console.log('response', response.status);
    if (response.status === 200) {
      yield put(fetchTripTrackingSuccess(response.data));
    } else if (response.status === 409) {
      window.location.reload();
    }
  } catch (e) {
    console.log({ e });
  }
}

function tripTimerHasPendingPodStatus(tripLike: any): boolean {
  const statuses = tripLike?.podOtpAndBalanceInfoTimer?.timerStatuses;
  return Array.isArray(statuses) && statuses.some((s: any) => s?.podStatusEnum === 'PENDING');
}

function* fetchTripTrackingDetailsV2(action: any) {
  const requestURL = UrlConfig.fetchTripTrackingV2(action.payload.tripId);
  try {
    const response = yield api2.get(requestURL);
    console.log('response', response.status);
    if (response.status === 200) {
      yield put(fetchTripTrackingSuccess(response.data));
      const data = response.data;
      const tripId = action.payload?.tripId;
      if (
        tripId &&
        data?.tripStage === 'TRIP_END' &&
        (data?.podOtpAndBalanceInfoTimer || data?.podAndOtpSubmitWidget) &&
        tripTimerHasPendingPodStatus(data)
      ) {
        yield put(startTripPodOtpPoll(tripId));
      } else {
        yield put(stopTripPodOtpPoll());
      }
    } else if (response.status === 404) {
      yield put(stopTripPodOtpPoll());
      yield put(fetchTripTrackingFailure(response.status));
    } else if (response.status === 409) {
      yield put(stopTripPodOtpPoll());
      window.location.reload();
    }
  } catch (e) {
    yield put(stopTripPodOtpPoll());
    const err = e as { response?: { status?: number } };
    const status = err?.response?.status;
    yield put(fetchTripTrackingFailure(status ?? e));
    if (status === 404) {
      const { history } = action.payload;
      if (history && typeof history.push === 'function') {
        history.push('/web-view/marketplace/active-loads');
      } else {
        window.location.href = window.location.origin + '/web-view/marketplace/active-loads';
      }
    }
    console.log({ e });
  }
}

const POD_OTP_POLL_INTERVAL_MS = 10000;

function* tripPodOtpPollingLoop(tripId: string): Generator<any, void, any> {
  const requestURL = UrlConfig.fetchTripPodOtp(tripId);
  try {
    while (true) {
      yield delay(POD_OTP_POLL_INTERVAL_MS);
      try {
        const response = yield api2.get(requestURL);
        if (response?.status === 200 && response.data) {
          const { podOtpAndBalanceInfoTimer, podAndOtpSubmitWidget } = response.data;
          yield put(
            mergeTripPodOtpWidgets({
              podOtpAndBalanceInfoTimer,
              podAndOtpSubmitWidget,
            }),
          );
          const tripTrackingData = yield select((s: any) => s.marketPlace.tripTrackingData);
          if (!tripTimerHasPendingPodStatus(tripTrackingData)) {
            yield put(stopTripPodOtpPoll());
            return;
          }
        }
      } catch {}
    }
  } catch {}
}

function* watchTripPodOtpPollingRoot(): Generator<any, void, any> {
  let pollTask;
  while (true) {
    const action = yield take([
      MarketPlaceActionTypes.START_TRIP_POD_OTP_POLL,
      MarketPlaceActionTypes.STOP_TRIP_POD_OTP_POLL,
    ]);
    if (action.type === MarketPlaceActionTypes.STOP_TRIP_POD_OTP_POLL) {
      if (pollTask) {
        yield cancel(pollTask);
        pollTask = undefined;
      }
      continue;
    }
    if (pollTask) {
      yield cancel(pollTask);
    }
    const nextTripId = action.payload as string;
    if (nextTripId) {
      pollTask = yield fork(tripPodOtpPollingLoop, nextTripId);
    }
  }
}

function* stopTripPodOtpPollOnTrackingReset(): Generator<any, void, any> {
  yield put(stopTripPodOtpPoll());
}

function* fetchTripSummary(action: any) {
  const requestURL = UrlConfig.fetchTripSummary(action.payload);
  try {
    const response = yield api.get(requestURL);

    yield put(fetchTripSummarySuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}
function* fetchTripSummaryV2(action: any) {
  const requestURL = UrlConfig.fetchTripSummaryV2(action.payload);
  try {
    const response = yield api.get(requestURL);

    yield put(fetchTripSummarySuccess(response.data));
  } catch (e) {
    console.log({ e });
  }
}

function* fetchPaymentHistory(action: any) {
  const requestURL = UrlConfig.fetchPaymentHistory(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(fetchPaymentHistorySuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}
function* fetchPaymentHistoryV2(action: any): any {
  const requestURL = UrlConfig.fetchPaymentHistoryV2(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(fetchPaymentHistorySuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* fetchLoadDetailsV2(action: any): any {
  const requestURL = UrlConfig.fetchLoadDetailsV2(action.payload.demandId);
  let headers = {};
  if (action.payload.utmSource) {
    headers = {
      'utm-source': action.payload.utmSource,
    };
  }
  try {
    const response = yield api.get(requestURL, {
      headers: headers,
    });
    if (response.data) {
      yield put(fetchLoadDetailsSuccess(response.data));
    }
  } catch (error) {
    console.log(error);
    Sentry.captureException(error);
    yield put(fetchLoadDetailsFailure());
  }
}
function* fetchLoadQuoteQuality(action: any): any {
  const requestURL = UrlConfig.fetchLoadQuoteQuality(action.payload);

  try {
    const response = yield api.get(requestURL);
    if (!response.data) {
      yield put(showSnackBar({ variant: 'error', message: 'Error in fetching quote quality.' }));
    }
    yield put(fetchLoadQuoteQualitySuccess(response.data));
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in fetching quote quality.' }));
    console.log({ e });
  }
}

function* postLoadQuote(action: any): any {
  const requestURL = UrlConfig.postLoadQuote(action.params.demandId);
  try {
    let response = null;
    if (action?.params?.utmSource) {
      response = yield api.put(requestURL, action.payload, {
        headers: { 'utm-source': `${action?.params?.utmSource || ''}` },
      });
    } else {
      response = yield api.put(requestURL, action.payload);
    }
    if (!response.data) {
      yield put(postLoadQuoteSuccess(response.data.data));
    } else {
      yield put(postLoadQuoteSuccess(response.data.data));
      yield put(fetchLoadDetailsStart({ demandId: action.params.demandId }));
    }
  } catch (e) {
    yield put(postLoadQuoteFailure(e));
    yield put(showSnackBar({ variant: 'error', message: 'Error in submitting bid.' }));
    console.log({ e });
  }
}

function* getSearchOptions(action: any) {
  const requestURL = UrlConfig.getSearchOptions(action.payload);

  try {
    const response = yield api.get(requestURL);

    if (!response.data.success) {
      yield put(showSnackBar({ variant: 'error', message: 'Error in fetching loading points.' }));
    }
    yield put(getSearchOptionsSuccess({ data: response.data, payload: action.payload }));
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in fetching loading points.' }));
    console.log({ e });
  }
}

function* getPlaceholderBannerDetails(action: any) {
  const requestURL = UrlConfig.getPlaceholderBannerDetail(action.payload);

  try {
    const response = yield api.get(requestURL);

    if (!response.data.success) {
      // yield put(showSnackBar({ variant: 'error', message: 'Error in fetching loading points.' }));
    }
    yield put(getPlaceholderBannerDetailSuccess(response.data));
  } catch (e) {
    // yield put(showSnackBar({ variant: 'error', message: 'Error in fetching loading points.' }));
    console.log({ e });
  }
}

async function uploadImageOnAws(data: any, action: any, podSuccesOnaws: any) {
  return await fetch(` ${data}`, {
    headers: { Accept: 'application/json, text/plain, /' },
    method: 'PUT',
    body: action.payload,
  })
    .then((response) => {
      podSuccesOnaws();
    })
    //Then with the data from the response in JSON...
    .then((data) => {})
    .catch((error) => {
      console.error('Error:', error);
    });
}
// function* uploadImageOnAws(data: any,action: any) {

//   const requestURL = UrlConfig.podUpdateDocAPiUrl(action.params);
//   try {
//     const response = yield api.post(data, action.payload);
//     yield put(podSuccesOnaws(true));

//     if (response.status == 200) {

//       yield put(podSuccesOnaws(true));
//     } else {
//     }
//   } catch (e) {
//     console.log('e,e',e)

//   }
// }

// function* getUploadedPod(resKey: any) {
//   const requestURL = UrlConfig.getUploadedDocImg(resKey.payload, resKey.typeImg);
//   try {
//     const response = yield api.get(requestURL);

//     yield put(getUploadedImagesSingleSuccess(response.data.data));
//   } catch (e) {}
// }

function* postUploadDocFunction(action: any) {
  // yield put (podSuccesOnaws( 'true'));
  // yield uploadImageOnAws('requestURL2',action,yield put(podSuccesOnaws('true')));

  let resKeyArray: any = [];
  const formData = {
    fileName: action.payload.name,
    docType: action.typeImg,
  };

  const requestURL = UrlConfig.postUploadDocUrl();

  try {
    const response = yield api2.post(requestURL, formData);
    let Key = response.data.data.imgResourceKey;
    let resKey = {
      payload: Key,
      typeImg: action.typeImg,
    };
    yield put(podResourceKey(Key, 'update'));
    const uploadUrl = response.data.data.imgUrl;
    let requestURL2 = uploadUrl.toString();
    // const callback= yield put(podSuccesOnaws(true))
    if (response.status == 200) {
      yield put(podAwsImgUrl(requestURL2));
      // yield uploadImageOnAws(requestURL2, action, yield put(podSuccesOnaws(true)));

      // yield getUploadedPod(resKey);
    }
  } catch (e) {
    // yield put(showSnackBar({ variant: 'error', message: 'Error in submitting.' }));
  }
}

function* fetchPodDetials(action: any) {
  const requestURL = UrlConfig.fetchPodDetailsApiUrl(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(fetchPodDetailsActionSuccess(response.data.data));
    yield put(getUploadedImagesSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}
function* updatePodDoc(action: any): any {
  const requestURL = UrlConfig.submitPod();
  try {
    const response = yield api2.post(requestURL, action.payload.formData);
    if (response.data) {
      yield put(showSnackBar({ variant: 'success', message: 'POD uploaded successfully' }));
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      yield put(PodPostUploadDocSubmitSuccess(true));
    }
  } catch (e) {
    console.log(e);
    Sentry.captureException(e);
    yield put(
      showSnackBar({
        message: e?.response?.data?.message,
        variant: 'error',
      }),
    );
    yield put(PodPostUploadDocSubmitSuccess(false));
  }
}

function* getUnloadingResults(action: any) {
  const requestURL: any = UrlConfig.searchUnloadingPoint(action.payload);

  try {
    const response = yield api.get(requestURL);

    // if (!response.data.success) {
    //   yield put(showSnackBar({ variant: 'error', message: 'Error in fetching quote quality.' }));
    // }
    yield put(unLoadingSearchResultsSuccess(response.data));
  } catch (e) {
    // yield put(showSnackBar({ variant: 'error', message: 'Error in fetching quote quality.' }));
    // console.log({ e });
  }
}

function* getVehcileAvailModal(action: any) {
  const requestURL: any = UrlConfig.getVehicleAvailModalShowAPiUrle();

  try {
    const response = yield api.get(requestURL);

    yield put(vehicleAvailModalShowSuccess(response.data.data));
  } catch (e) {}
}
function* surveyGetQuestionSaga(action: any) {
  const requestURL: any = UrlConfig.getSurveyQuestionApiUrl();
  try {
    const response = yield api.get(requestURL);
    console.log('response', response);

    if (response.status == 200) {
      yield put(surveyGetQuestionSuccess(response.data));
    }
  } catch (e) {}
}

function* submitSurveyForm(action: any) {
  const requestURL = UrlConfig.postSurveyFormApiUrl();
  try {
    const response = yield api.post(requestURL, action.payload);
  } catch (e) {}
}

function* submitOtpFormFunction(action: any) {
  const requestURL = UrlConfig.postOtpApiUrl();
  try {
    const response = yield api.post(requestURL, action.payload.formData);
    if (response.data) {
      action.payload.saveCorrectOtpEvents();
      action.payload.history.push(`/web-view/marketplace/trips/details/v2/${action.payload.formData.tripId}`);
    }
  } catch (e) {
    console.log(e);
    action.payload.updateOtpErrorAlert();
    yield put(otpSubmitActionFailure(e));
  }
}

function* submitOtpStageFormFunction(action: any) {
  const requestURL = UrlConfig.postStageOtpApiUrl();
  try {
    const response = yield api.post(requestURL, action.payload.formDataStage);
    if (response.data) {
      yield put(otpStageSubmitActionSuccess(response.data));
    } else {
      console.log('error');
    }
  } catch (e) {
    console.log(e?.response?.data);
    if (e?.response?.status === 422) {
      yield put(
        fetchAdvanceStateViewStart({
          tripId: action.payload.formDataStage?.tripId,
          state: action.payload.formDataStage?.state,
          //  tripId: 2064525, //action.payload.formDataStage?.tripId,
          //  state: 'GOING_TO_LOAD', //action.payload.formDataStage?.state,
        }),
      );
      // yield put(tripDetailStateChangeConfirmWarningStart(e?.response?.data));
    }
    if (action.payload.updateOtpErrorAlert) {
      action.payload.updateOtpErrorAlert();
    }

    yield put(otpSubmitActionFailure(e));
  }
}

function* tripDetailStateChangeValidationSaga(action: any) {
  const requestURL = UrlConfig.tripAdvanceState();
  try {
    const response = yield api.post(requestURL, action.payload);
    if (response.data) {
      yield put(tripDetailStateChangeConfirmWarningStop());
      window.location.reload();
    }
  } catch (e) {
    console.log(e);
    yield put(tripDetailStateChangeValidationFailure(e));
  }
}

function* postInitiateMembershipPayment(action: any) {
  const requestURL = UrlConfig.postInitiateMembershipPayment(action.payload);

  try {
    const response = yield api.post(requestURL);
    if (response.data.success) {
      yield put(initiateMembershipPaymentSuccess(response));
    }
  } catch (e) {
    yield put(initiateMembershipPaymentFailure(e));
    console.log({ e });
  }
}

function* postMembershipPaymentDetails(action: any) {
  const requestURL = UrlConfig.postMembershipPaymentDetails(action.payload);

  try {
    const response = yield api.post(requestURL, action.payload);
    if (response.data.success) {
      yield put(membershipPaymentProcessSuccess(response));
    }
  } catch (e) {
    yield put(membershipPaymentProcessFailure(e));
    console.log({ e });
  }
}

function* fetchOperatorProfileData() {
  const requestURL = UrlConfig.fetchOperatorProfileGetApiUrle();
  try {
    const response = yield api.get(requestURL);

    if (response.status === 200) {
      console.log(response.data);
      yield put(
        fetchOperatorProfileDetailsSuccess(
          //   name: response.data.name,
          //   phoneNumber: response.data.phoneNumber,
          //   kycStatus: response.data.kycStatus,
          //   subscriptionStatus: response.data.subscriptionStatus,
          //   cardsWidget: {
          //     title: response.data.cardsWidget.title,
          //     cards: [...response.data.cardsWidget.cards],
          //   },
          response.data,
        ),
      );
    }
  } catch (e) {
    yield put(fetchOperatorProfileDetailsFailure({}));
    console.log({ e });
  }
}
function* fetchAppConfig(action: any): any {
  const requestURL = UrlConfig.getSurveyQuestionApiUrl();

  try {
    const response = yield api.get(requestURL);
    if (response.data) {
      yield put(fetchAppConfigSuccess(response.data.data));
    }
  } catch (e) {
    yield put(fetchAppConfigFailure());
    console.log({ e });
  }
}

function* awsUploader(action: any): any {
  const requestURL = UrlConfig.postUploadDocUrl();
  const demandId = action.payload.demandId;
  const tripId = action.payload.tripId;
  const options = {
    fileName: action.payload.file.name,
    docType: action.payload.docType,
  };
  try {
    const response = yield api2.post(requestURL, options);
    const resourceKey = response.data.data.imgResourceKey;
    const imgUrl = response.data.data.imgUrl;

    yield put(uploadImgAwsSuccess({ tripId, demandId, resourceKey, imgUrl }));
    try {
      const response = yield fetch(imgUrl, {
        headers: { Accept: 'application/json, text/plain, /' },
        method: 'PUT',
        body: action.payload.file,
      });
      if (response.ok) {
        yield put(imgUploadStatus({ tripId, demandId, resourceKey }));
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  } catch (e) {
    Sentry.captureException(e);
  }
}

function* submitPod(action: any): any {
  const requestURL = UrlConfig.submitPod();
  const { demandId, tripId, resourceKeys, callback } = action.payload;
  const formData = {
    demandId,
    tripId,
    podResourceKeys: resourceKeys,
  };
  try {
    const response = yield api2.post(requestURL, formData);
    const document = response.data.data;
    yield put(submitBulkUploadSuccess(document));
    callback();
    yield put(resetPODDto());
  } catch (error) {
    console.log(error);
    Sentry.captureException(error);
    yield put(submitBulkUploadFailure());
  }
}

function* postOperatorResponseEvent(action: any) {
  const requestURL = UrlConfig.sendResponseEvent(action.payload);

  try {
    const response = yield api.post(requestURL, action.payload);
    if (response.data.success) {
      yield put(sendResponseEventSuccess(response));
    }
  } catch (e) {
    yield put(sendResponseEventFailure(e));
    Sentry.captureException(e);
    console.log({ e });
  }
}

function* getOperatorTdsDetailsSaga(action: any) {
  const requestURL: any = UrlConfig.getOperatordetails(action.payload);
  try {
    const response = yield api2.get(requestURL);
    yield put(fetchOperatorDetailsSuccess(response));
  } catch (e) {
    yield put(fetchOperatorDetailsFailure(e));
    console.log({ e });
  }
}

function* getInitiateTdsDeclarationSaga(action: any) {
  const requestURL = UrlConfig.initiateTdsDeclaration(action.payload);
  try {
    const response = yield api2.post(requestURL, action.payload);
    yield put(initiateOperatorTdsDeclarationFailure(response));
  } catch (e) {
    yield put(initiateOperatorTdsDeclarationSuccess(e));
    console.log({ e });
  }
}
function* getAppConfigV2(action: any): any {
  const requestURL = UrlConfig.appConfigV2();
  try {
    const response = yield api2.get(requestURL);
    yield put(getAppConfigV2Success(response.data));
  } catch (e) {
    yield put(getAppConfigV2Failure());
    console.log({ e });
  }
}
function* patchAppConfig(action: any): any {
  const requestURL = UrlConfig.appConfigV2();
  try {
    const response = yield api2.patch(requestURL, action.payload);
    yield put(patchAppConfigV2Success());
  } catch (e) {
    yield put(patchAppConfigV2Failure());
    console.log({ e });
  }
}
function* fetchTripRemarks(action: any): any {
  const { tripId } = action.payload;
  const requestURL = UrlConfig.tripRemarks(tripId, action.payload.action);
  try {
    const response = yield api2.get(requestURL);
    yield put(getTripRemarksSuccess(response.data));
  } catch (e) {
    yield put(getTripRemarksFailure());
  }
}
function* fetchTripSlots(action: any): any {
  const { tripId, location } = action.payload;
  const requestURL = UrlConfig.slots(tripId, location);
  try {
    const response = yield api2.get(requestURL);
    yield put(getTripSlotsSuccess(response.data));
  } catch (e) {
    yield put(getTripSlotsFailure());
  }
}

function* fetchSubscriptionConfig(action: any): any {
  const requestURL = UrlConfig.getSubscribtionCongigUrl();
  try {
    const response = yield api2.get(requestURL);
    yield put(fetchSubscriptionSuccess(response.data));
  } catch (e) {
    yield put(fetchSubscriptionFailure());
  }
}
function* patchUpdateRemarks(action: any): any {
  const { tripId, payload } = action.payload;
  const requestURL = UrlConfig.updateRemarks(tripId);
  try {
    const response = yield api2.patch(requestURL, payload);
    if (response) {
      yield put(showSnackBar({ variant: 'success', message: 'Successfully Submitted' }));
      window.location.reload();
    }
    yield put(getTripSlotsSuccess(response.data));
  } catch (e) {
    yield put(getTripSlotsFailure());
  }
}

function* updateReasonSubmit(action: any): any {
  const { demandId, payload } = action.payload;
  const requestURL = UrlConfig.postCancelReasonActiveLoad(demandId);
  try {
    const response = yield api2.post(requestURL, action.payload);
    yield put(updateCancelReasonSuccess(response.data));
  } catch (e) {
    yield put(updateCancelReasonFailure());
  }
}

function* fetchOperatorTicket(action: any) {
  const requestURL = UrlConfig.fetchOperatorTicketUrl(action.payload);
  try {
    const response = yield api2.get(requestURL);
    yield put(fetchOperatorTicketSuccess(response.data));
  } catch (e) {
    yield put(fetchOperatorTicketFailure(e));
    console.log({ e });
  }
}

function* fetchOperatorPolicyStatus(action: any) {
  const requestUrl = UrlConfig.fetchOperatorPolicyUrl(action.payload);
  try {
    const response = yield api2.get(requestUrl);
    yield put(fetchOperatorPolicyStatusSuccess(response.data));
  } catch (e) {
    yield put(fetchOperatorPolicyStatusFailure(e));
    console.log(e);
  }
}

function* postOperatorPolicyAcceptStart(action: any) {
  const requestURL = UrlConfig.postOperatorPolicyAcceptUrl();
  try {
    const response = yield api2.post(requestURL, action.payload.formData);
    yield put(fetchOperatorPolicyStatusReset());
  } catch (e) {
    yield put(postOperatorPolicyAcceptFailure(e));
    console.log(e);
  }
}
function* fetchTripFilters(action: any): any {
  const requestURL = UrlConfig.fetchTripFilter();
  try {
    const response = yield api2.get(requestURL);

    yield put(fetchTripFiltersDataSuccess(response.data));
    const filterJSON = JSON.parse(localStorage.getItem('tripFilter') || '');
    const selectedFilterKey = response.data.stateFilters.find((filter: Filter) => filter?.key === filterJSON).key;
    if (selectedFilterKey) {
      yield put(applyTripFilter({ key: selectedFilterKey }));
    }
  } catch (e) {
    yield put(fetchTripFiltersDataFailure());
    console.log(e);
  }
}

function* fetchSettings(): any {
  const requestURL = UrlConfig.settingsUrl();
  try {
    const response = yield api2.get(requestURL);
    yield put(fetchSettingsSuccess(response.data));
  } catch (e) {
    yield put(fetchSettingsFailure());
    console.log(e);
  }
}
function* getRatingTrainingVideos(action: any): any {
  const requestURL = UrlConfig.ratingTraining(action?.payload?.page);
  try {
    const response = yield api2.get(requestURL);
    yield put(getRatingTrainingSuccess(response.data));
  } catch (e) {
    yield put(getRatingTrainingFailure());
    console.log(e);
  }
}

function* saveSettings(action: any): any {
  const requestURL = UrlConfig.settingsUrl();
  try {
    const response = yield api2.post(requestURL, action.payload);
    yield put(saveSettingsSuccess(response.data));
  } catch (e) {
    yield put(saveSettingsFailure());
  }
}
function* demandEditConfirmation(action: any): any {
  const formData = {
    type: action.payload?.type,
    tripExpenseId: action.payload?.tripExpenseId,
  };

  console.log('formData', formData);

  const requestURL = UrlConfig.demandEditurl(action?.payload?.tripId);
  try {
    const response = yield api2.post(requestURL, formData);
    yield put(demandEditConfirmationSuccess(response.data));
  } catch (e) {
    yield put(demandEditConfirmationsFailure());
  }
}

function* patchPanAdhaarLink(action: any): any {
  const requestURL = UrlConfig.setPanAdhaarLinking();
  try {
    yield api2.patch(requestURL);
  } catch (e) {}
}

function* getOperatorInvoice(action: any) {
  const requestURL = UrlConfig.getOperatorInvoiceUrl(action.payload.filepath);
  try {
    const response = yield api2.get(requestURL);
    yield put(getInvoiceSuccess(response.data));
  } catch (e) {
    yield put(getInvoiceFailure());
    yield put(showSnackBar({ variant: 'error', message: 'Error in getting Invoice' }));
  }
}

function* patchOperatorInvoice(action: any) {
  const { tripId, patchInvoice } = action.payload;
  const requestURL = UrlConfig.patchOperatorInvoiceUrl(tripId);
  try {
    const response = yield api2.patch(requestURL, patchInvoice);
    yield put(showSnackBar({ variant: 'success', message: 'Invoice Updated SuccessFully' }));
    yield put(patchInvoiceSuccess(response.data));
  } catch (e) {
    yield put(patchInvoiceFailure());
    yield put(showSnackBar({ variant: 'error', message: 'Error in updating Invoice' }));
  }
}

function* uploadImageWatcher(action: any) {
  const { tripID, file, extension } = action.payload;
  const requestUrl = UrlConfig.uploadUrl(tripID, extension);
  try {
    const response: AxiosResponse = yield api2.get(requestUrl);
    yield put(uploadImageSuccess(response.data));
    yield put(uploadImageAwsRequest({ ...response.data, file }));
  } catch (error) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in updating Invoice' }));
    Sentry.captureException(error);
    yield put(uploadImageFailure());
  }
}

function* uploadAwsWatcher(action: any) {
  const { imgUrl } = action.payload;
  const { file } = action.payload;
  try {
    const headers = {
      'Content-Type': file.type,
      token: getToken(),
      'x-app-version': ' ',
      'x-app-platform': ' ',
    };

    const instance = axios.create({
      ...S3Instance.defaults,
      headers: headers,
    });

    const response: AxiosResponse = yield instance.put(imgUrl, file);

    yield put(uploadImageAwsSuccess(action.payload));
  } catch (error) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in updating Invoice' }));
    yield put(uploadImageAwsFailure());
    Sentry.captureException(error);
  }
}

function* watchFetchWeLang() {
  try {
    const requestUrl = UrlConfig.fetchWeLangKeyValues();
    const response: AxiosResponse = yield api2.get(requestUrl);
    if (response.data) {
      yield put(fetchWeLangSuccess(response.data));
    }
  } catch (error) {
    yield put(fetchWeLangFailure());
  }
}

function* watchFetchTrainingContent(action: any) {
  const { trainingType, source, tripId } = action.payload;
  const requestUrl = UrlConfig.fetchTrainingContent(trainingType, source, tripId);
  try {
    const response: AxiosResponse = yield api2.get(requestUrl);
    yield put(fetchTrainingContentSuccess(response.data));
  } catch (error) {
    Sentry.captureException(error);
    yield put(fetchTrainingContentFailure());
  }
}

function* watchFetchTrainingContentV2(action: any) {
  const { trainingType, tripId } = action.payload;
  const requestUrl = UrlConfig.fetchTrainingContentV2(trainingType, tripId);
  try {
    const response: AxiosResponse = yield api2.get(requestUrl);
    yield put(fetchTrainingContentV2Success(response.data));
  } catch (error) {
    Sentry.captureException(error);
    yield put(fetchTrainingContentV2Failure());
  }
}

function* watchSessionUpdateRequest(action: any) {
  const { tripId, referenceId, actionType } = action.payload;
  const requestUrl = UrlConfig.updateSessionVariablesUrl();
  try {
    const response: AxiosResponse = yield api2.post(requestUrl, {
      tripId,
      referenceId,
      actionType,
    });
    yield put(sessionUpdateSuccess(response.data));
  } catch (error) {
    Sentry.captureException(error);
    yield put(sessionUpdateFailure());
  }
}

function* watchFetchDetentionContent(action: any) {
  const { tripId, detentionTypeInfo } = action.payload;
  const requestUrl = UrlConfig.fetchDetentionContent(tripId, detentionTypeInfo);
  try {
    const response: AxiosResponse = yield api2.get(requestUrl);
    yield put(fetchDetentionContentSuccess(response.data));
  } catch (error) {
    Sentry.captureException(error);
    yield put(fetchDetentionContentFailure());
  }
}

function* watchSubmitTraining(action: any) {
  const { type, tripId } = action.payload;
  const requestUrl = UrlConfig.submitCompleteTraining(type, tripId);
  try {
    yield api2.put(requestUrl);
    yield put(submitTrainingCompletionSuccess());
  } catch (error) {
    Sentry.captureException(error);
    yield put(submitTrainingCompletionFailure());
  }
}

function* watchPostAcknowledgement(action: any) {
  const requestURL = UrlConfig.postAcknowledgementUrl();
  try {
    const response: AxiosResponse = yield api2.post(requestURL, action.payload);
    yield put(postAcknowledgementSuccess(response));
  } catch (error) {
    yield put(postAcknowledgementFailure());
  }
}

function* watchFetchRateCards() {
  const request = UrlConfig.odvtRateCardStatus();

  try {
    const response: AxiosResponse<RateCardsResponseDTO> = yield api2.get(request);
    yield put(asyncFetchRateCardsSuccess(response.data));
  } catch (error) {
    yield put(asyncFetchRateCardsFailure());
  }
}
function* watchSubmitRateCardInput(action: any) {
  const request = UrlConfig.odvtRateCardStatus();
  try {
    yield api2.post(request, action.payload);
    yield put(asyncPostSubmitRateCardResponseSuccess());
  } catch (error) {
    yield put(asyncPostSubmitRateCardResponseFailure());
  }
}

function* getRemarksList(action: any): any {
  const { tripId } = action.payload;
  const requestURL = UrlConfig.getRemarks(tripId, action.payload.action);
  try {
    let response = yield api2.get(requestURL);
    yield put(asyncGetRemarksListSuccess(response.data));
  } catch (e) {
    yield put(asyncGetRemarksListFailure());
  }
}

function* updateDelayRemarks(action: any): any {
  const requestURL = UrlConfig.updateDelayRemarks(action?.payload?.tripId);
  try {
    let response = yield api2.patch(requestURL, action.payload.payload);
    yield put(updateDelayRemarksSuccess(response.data));
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in updating remarks' }));
    yield put(updateDelayRemarksFailure(e));
  }
}

function* reasonSubmitSaga(action: any): Generator<any, void, any> {
  console.log('reasonSubmitSaga called with action:', action);
  const requestURL = UrlConfig.postReasonSubmit();
  console.log('Making API call to:', requestURL);
  try {
    const response = yield api2.post(requestURL, action.payload);
    console.log('API response:', response);
    yield put(reasonSubmitSuccess(response.data));
    if (action.payload.onSuccess) {
      action.payload.onSuccess();
    }
    if (action.payload.onClose) {
      action.payload.onClose();
    }
  } catch (e) {
    console.error('API call failed:', e);
    yield put(reasonSubmitFailure(e));
    yield put(showSnackBar({ variant: 'error', message: 'Error submitting reason. Please try again.' }));
    if (action.payload.onClose) {
      action.payload.onClose();
    }
  }
}

function* fetchAdvanceStateViewSaga(action: any): Generator<any, void, any> {
  const requestURL = UrlConfig.fetchAdvanceStateView();
  try {
    const response = yield api2.post(requestURL, action.payload);
    yield put(fetchAdvanceStateViewSuccess(response.data));
  } catch (e) {
    yield put(fetchAdvanceStateViewFailure(e));
  }
}

function* marketPlaceSaga() {
  yield fork(watchTripPodOtpPollingRoot);
  yield takeEvery(MarketPlaceActionTypes.TRIP_TRACKING_DATA_RESET, stopTripPodOtpPollOnTrackingReset);
  yield takeLatest(MarketPlaceActionTypes.FETCH_OPERATOR_TRIPS_START, fetchOperatorTrips);
  yield takeLatest(MarketPlaceActionTypes.FETCH_STATES_START, fetchStates);
  yield takeLatest(MarketPlaceActionTypes.FETCH_LOADS_START, fetchOperatorLoads);
  yield takeLatest(MarketPlaceActionTypes.SAVE_OP_RESPONSE_START, saveOpResponse);
  yield takeLatest(MarketPlaceActionTypes.FETCH_TRIP_EXPENSE_START, fetchTripExpenses);
  yield takeLatest(MarketPlaceActionTypes.FETCH_TRIP_EXPENSE_START_V2, fetchTripExpensesV2);
  yield takeLatest(MarketPlaceActionTypes.FETCH_TRIP_SUMMARY_START, fetchTripSummary);
  yield takeLatest(MarketPlaceActionTypes.FETCH_TRIP_SUMMARY_START_V2, fetchTripSummaryV2);
  yield takeLatest(MarketPlaceActionTypes.FETCH_PAYMENT_HISTORY_START, fetchPaymentHistory);
  yield takeLatest(MarketPlaceActionTypes.FETCH_PAYMENT_HISTORY_START_V2, fetchPaymentHistoryV2);
  yield takeLatest(MarketPlaceActionTypes.CALL_POC_START, callPoc);
  yield takeLatest(MarketPlaceActionTypes.FETCH_LOAD_DETAILS_START, fetchLoadDetailsV2);
  yield takeLatest(MarketPlaceActionTypes.FETCH_LOAD_QUOTE_QUALITY_START, fetchLoadQuoteQuality);
  yield takeLatest(MarketPlaceActionTypes.POST_LOAD_QUOTE_START, postLoadQuote);
  yield takeLatest(MarketPlaceActionTypes.GET_SEARCH_OPTIONS_START, getSearchOptions);
  yield takeLatest(MarketPlaceActionTypes.GET_PLACEHOLDER_BANNER_DETAILS_START, getPlaceholderBannerDetails);

  yield takeLatest(MarketPlaceActionTypes.POST_UPLOAD_DOC_POD_START, postUploadDocFunction);

  yield takeLatest(MarketPlaceActionTypes.FETCH_POD_DETAILS_START, fetchPodDetials);

  yield takeLatest(MarketPlaceActionTypes.POST_POD_DATA_UPDATE_START, updatePodDoc);
  yield takeLatest(MarketPlaceActionTypes.UNLOADING_SEARCH_RESULTS_START, getUnloadingResults);

  yield takeLatest(MarketPlaceActionTypes.VEHCILE_AVAIL_MODAL_SHOW_START, getVehcileAvailModal);

  yield takeLatest(MarketPlaceActionTypes.SURVEY_GET_QUESTION_START, surveyGetQuestionSaga);

  yield takeLatest(MarketPlaceActionTypes.POST_SURVEY_FORM_START, submitSurveyForm);

  yield takeLatest(MarketPlaceActionTypes.INITIATE_MEMBERSHIP_PAYMENT_START, postInitiateMembershipPayment);

  yield takeLatest(MarketPlaceActionTypes.MEMBERSHIP_PAYMENT_PROCESS_START, postMembershipPaymentDetails);

  yield takeLatest(MarketPlaceActionTypes.POST_OTP_START, submitOtpFormFunction);

  yield takeLatest(MarketPlaceActionTypes.POST_OTP_STAGE_START, submitOtpStageFormFunction);

  // TRIP DETAIL - STATE CHANGE VALIDATION
  yield takeLatest(
    MarketPlaceActionTypes.TRIP_DETAIL_STATE_CHANGE_VALIDATION_START,
    tripDetailStateChangeValidationSaga,
  );

  yield takeLatest(MarketPlaceActionTypes.FETCH_OPERATOR_PROFILE_START, fetchOperatorProfileData);
  yield takeLatest(MarketPlaceActionTypes.FETCH_APP_CONFIG, fetchAppConfig);

  yield takeLatest(MarketPlaceActionTypes.FETCH_TRIP_TRACKING_DETAILS_START, fetchTripTrackingDetails);
  yield takeLatest(MarketPlaceActionTypes.FETCH_TRIP_TRACKING_DETAILS_START_V2, fetchTripTrackingDetailsV2);
  yield takeLatest(MarketPlaceActionTypes.POST_IMG_AWS, awsUploader);
  yield takeLatest(MarketPlaceActionTypes.SUBMIT_BULK_POD, submitPod);
  yield takeLatest(MarketPlaceActionTypes.SEND_RESPONSE_EVENT_START, postOperatorResponseEvent);

  yield takeLatest(MarketPlaceActionTypes.FETCH_OPERATOR_DETAILS_TDS_START, getOperatorTdsDetailsSaga);
  yield takeLatest(MarketPlaceActionTypes.INITIATE_OPERATOR_TDS_DECLARATION_TDS_START, getInitiateTdsDeclarationSaga);
  yield takeLatest(MarketPlaceActionTypes.GET_APP_CONFIG_V2, getAppConfigV2);
  yield takeLatest(MarketPlaceActionTypes.PATCH_APP_CONFIG_V2, patchAppConfig);
  yield takeLatest(MarketPlaceActionTypes.GET_TRIP_REMARKS, fetchTripRemarks);
  yield takeLatest(MarketPlaceActionTypes.GET_TIME_SLOTS, fetchTripSlots);
  yield takeLatest(MarketPlaceActionTypes.PATCH_REMARKS, patchUpdateRemarks);
  yield takeLatest(MarketPlaceActionTypes.FETCH_OPERATOR_TICKETS_START, fetchOperatorTicket);
  yield takeLatest(MarketPlaceActionTypes.FETCH_OPERATOR_POLICY_STATUS_START, fetchOperatorPolicyStatus);
  yield takeLatest(MarketPlaceActionTypes.POST_OPERATOR_POLICY_ACCEPT_START, postOperatorPolicyAcceptStart);
  yield takeLatest(MarketPlaceActionTypes.FETCH_SUBSCRIPTION_CONFIG, fetchSubscriptionConfig);
  yield takeLatest(MarketPlaceActionTypes.POST_CANCEL_REASON, updateReasonSubmit);
  yield takeLatest(MarketPlaceActionTypes.FETCH_TRIP_FILTERS, fetchTripFilters);
  yield takeLatest(MarketPlaceActionTypes.FETCH_SETTINGS_REQUEST, fetchSettings);
  yield takeLatest(MarketPlaceActionTypes.SAVE_SETTINGS_REQUEST, saveSettings);
  yield takeLatest(MarketPlaceActionTypes.PATCH_PAN_ADHAAR, patchPanAdhaarLink);
  yield takeLatest(MarketPlaceActionTypes.DEMAND_EDIT_CONFIRMATION_REQUEST, demandEditConfirmation);
  yield takeLatest(MarketPlaceActionTypes.GET_RAITING_TRAINING_REQUEST, getRatingTrainingVideos);
  yield takeLatest(MarketPlaceActionTypes.GET_INVOICE_REQUEST, getOperatorInvoice);
  yield takeLatest(MarketPlaceActionTypes.PATCH_INVOICE_REQUEST, patchOperatorInvoice);
  yield takeLatest(MarketPlaceActionTypes.UPLOAD_IMAGE_REQUEST, uploadImageWatcher);
  yield takeLatest(MarketPlaceActionTypes.UPLOAD_IMAGE_AWS_REQUEST, uploadAwsWatcher);
  yield takeLatest(MarketPlaceActionTypes.FETCH_WELANG, watchFetchWeLang);
  yield takeLatest(MarketPlaceActionTypes.FETCH_WELANG, watchFetchWeLang);
  yield takeLatest(MarketPlaceActionTypes.GET_TRAINING_CONTENT_REQUEST, watchFetchTrainingContent);
  yield takeLatest(MarketPlaceActionTypes.FETCH_TRAINING_CONTENT_V2_REQUEST, watchFetchTrainingContentV2);
  yield takeLatest(MarketPlaceActionTypes.PUT_COMPLETE_TRAINING_REQUEST, watchSubmitTraining);
  yield takeLatest(MarketPlaceActionTypes.POST_ACKNOWLEDGEMENT, watchPostAcknowledgement);
  yield takeLatest(MarketPlaceActionTypes.SESSION_UPDATE_REQUEST, watchSessionUpdateRequest);
  yield takeLatest(MarketPlaceActionTypes.FETCH_DETENTION_CONTENT_REQUEST, watchFetchDetentionContent);
  yield takeLatest(MarketPlaceActionTypes.FETCH_RATE_CARDS, watchFetchRateCards);
  yield takeLatest(MarketPlaceActionTypes.SUBMIT_USER_RATE_CARD_RESPONSE, watchSubmitRateCardInput);
  yield takeLatest(MarketPlaceActionTypes.GET_REMARKS_LIST, getRemarksList);
  yield takeLatest(MarketPlaceActionTypes.UPDATE_DELAY_REMARKS, updateDelayRemarks);
  yield takeLatest(MarketPlaceActionTypes.REASON_SUBMIT_START, reasonSubmitSaga);
  yield takeLatest(MarketPlaceActionTypes.FETCH_ADVANCE_STATE_VIEW_START, fetchAdvanceStateViewSaga);
}

export default marketPlaceSaga;
